(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('call-type', {
            parent: 'entity',
            url: '/call-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.callType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/call-type/call-types.html',
                    controller: 'CallTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('callType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('call-type-detail', {
            parent: 'entity',
            url: '/call-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.callType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/call-type/call-type-detail.html',
                    controller: 'CallTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('callType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CallType', function($stateParams, CallType) {
                    return CallType.get({id : $stateParams.id});
                }]
            }
        })
        .state('call-type.new', {
            parent: 'call-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/call-type/call-type-dialog.html',
                    controller: 'CallTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('call-type', null, { reload: true });
                }, function() {
                    $state.go('call-type');
                });
            }]
        })
        .state('call-type.edit', {
            parent: 'call-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/call-type/call-type-dialog.html',
                    controller: 'CallTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CallType', function(CallType) {
                            return CallType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('call-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('call-type.delete', {
            parent: 'call-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/call-type/call-type-delete-dialog.html',
                    controller: 'CallTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CallType', function(CallType) {
                            return CallType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('call-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
